/** Stands in for an Angular screen that has not been ported yet. Every one must be gone before cutover. */
export function NotMigrated({ component, url }: { component: string; url: string }) {
  return (
    <div style={{ padding: 16 }} data-testid="not-migrated" data-component={component}>
      <strong>Not migrated yet</strong>: {component} <code>{url}</code>
    </div>
  );
}
